import authInstance from "../Interceptor";

export const AddCustomerEffect = (data, config) => {
  return authInstance.post("/customers/insertcustomer", data, config);
};

export const EditCustomerEffect = (CustomerId, updatedData) => {
  return authInstance.put(
    `/customers/updatecustomer/${CustomerId}`,
    updatedData
  );
};

export const DeleteCustomerEffect = (CustomerId) => {
  return authInstance.delete(`/customers/deletecustomer/${CustomerId}`);
};

export const ViewCustomerEffect = (CustomerId) => {
  return authInstance.get(`/customers/getcustomer?customer_id=${CustomerId}`);
};

export const ViewAllCustomerEffect = (payload) => {
  return authInstance.get(
    `/customers/list?pagination_required=true&pagesize=10&pageNo=${payload.pageNo}&search_key=${payload.search_key}`
  );
};

export const ViewAllSearchCustomersEffect = () => {
  return authInstance.get(`/customers/list`);
};
